/* eslint no-console:off, no-useless-escape:off */

export const hireMe = (): void => {
  console.log(String.raw`
 _    _ _____ _____  ______   __  __ ______
| |  | |_   _|  __ \|  ____| |  \/  |  ____|
| |__| | | | | |__) | |__    | \  / | |__
|  __  | | | |  _  /|  __|   | |\/| |  __|
| |  | |_| |_| | \ \| |____  | |  | | |____
|_|  |_|_____|_|  \_\______| |_|  |_|______(_)
`);
};
